import { render, staticRenderFns } from "./NoChat.vue?vue&type=template&id=8a0e148a&"
import script from "./NoChat.vue?vue&type=script&lang=js&"
export * from "./NoChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports